var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20039 1.44775C6.73985 1.87689 6.37046 2.39439 6.11426 2.96939C5.85806 3.54439 5.7203 4.16509 5.70919 4.79449C5.69809 5.42388 5.81387 6.04906 6.04962 6.63274C6.28538 7.21641 6.63628 7.74663 7.0814 8.19174C7.52652 8.63686 8.05673 8.98776 8.64041 9.22352C9.22408 9.45928 9.84926 9.57506 10.4787 9.56395C11.108 9.55285 11.7288 9.41508 12.3038 9.15888C12.8787 8.90268 13.3963 8.5333 13.8254 8.07275C13.6266 11.3446 10.9104 13.9359 7.58852 13.9359C4.13602 13.9359 1.33789 11.1378 1.33789 7.68588C1.33789 4.364 3.92914 1.64775 7.20039 1.44775Z",
    fill: "#173963"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.777a5495da6b1d279ff6fe320693bd93.svg";
export { ForwardRef as ReactComponent };